import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'primeng/colorpicker';

@Component({
  selector: 'elcia-color-picker',
  imports: [ColorPickerModule, ReactiveFormsModule],
  templateUrl: './color-picker.html',
  styleUrl: './color-picker.scss',
})
export class ColorPicker {
  control = input.required<FormControl<string | null>>();
  appendTo = input<'body' | 'self'>('body');
}
